const state = {
  ...window.__initialAppState.modules.productPage
};

export default state;
